import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { TurnosService } from "app/services/turnos.service";
import { MercadopagoService } from "app/services/mercadopago.service";
import { NgxMaterialTimepickerTheme } from "ngx-material-timepicker";
import * as moment from "moment";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SpinnerService } from "app/services/spinner.service";
import { NotificationComponent } from "app/shared/notification/notification.component";
import { BehaviorSubject, combineLatest, of, Subscription } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { TipoDocumentoService } from "../../services/tipo-documento.service";
import { ResponsiveService } from "../../services/responsive.service";
import { ServicioService } from "../../services/servicio.service";
import { TipoDocumento } from "../../models/tipoDocumento.interface";
import { Paciente } from "../../models/paciente.interface";
import { diasSemanaOrdenAnglo, generarSlotsParaDia, slotsLibres, tramosDelDiaAgenda } from "../../utils/turnos.utils";
import { MatSelectChange } from "@angular/material/select";
import { Medico, MedicoConDiasTurno } from "../../models/medico.interface";
import { CentroMedico } from "../../models/centroMedico.interface";
import { Agenda } from "../../models/agenda.interface";
import { id } from "@swimlane/ngx-charts";
import {
  notZeroValidator,
  tiempoDesdeValidator,
} from "../../utils/custom-validators.utils";
import { camposFaltantes, mensajeError } from "../../utils/form-errors.utils";

@Component({
  selector: "app-turno-add-dialog",
  templateUrl: "./turno-add-dialog.component.html",
  styleUrls: ["./turno-add-dialog.component.scss"],
})
export class TurnoAddDialogComponent implements OnInit {
  //
  formularioTurno = new FormGroup({
    id: new FormControl(""),
    titulo: new FormControl("Turno"),
    especialidad: new FormControl("0"),
    especialidadBuscador: new FormControl(""),
    servicio: new FormControl(""),
    detalle: new FormControl(""),
    id_paciente: new FormControl("", Validators.required),
    pacienteBuscador: new FormControl(""),
    id_medico: new FormControl("", Validators.required),
    medicoBuscador: new FormControl(""),
    centroMedico: new FormControl("", [
      Validators.required,
      notZeroValidator(),
    ]),
    centroMedicoBuscador: new FormControl(""),
    fechaDesde: new FormControl("", [
      Validators.required,
      tiempoDesdeValidator(),
    ]),
    fechaHasta: new FormControl(""),
    tiempoDesde: new FormControl("", Validators.required),
    tiempoHasta: new FormControl(""),
    modoRango: new FormControl(false),
    rangoFechaDesde: new FormControl(""),
    rangoFechaHasta: new FormControl(""),
    diasSemanaRango: new FormControl([] as number[]),
    horaDesdeRango: new FormControl(""),
  });
  listaEspecialidades: any;
  filtroEspecialidades: any;
  listaCompletaMedicos: any;
  general: any;
  tipoUsuario: any;
  fechaError: any;
  listaPacientes: any;
  listaMedicos: any;
  listaCentrosMedicos: any;
  filtroPacientes: any;
  filtroMedicos: any;
  filtroCentroMedicos: any;
  tiposDocumentos: TipoDocumento[];
  turno: any;
  usuario: any;
  editar: any;
  medicoSelecionado: Medico = null;
  pacienteSeleccionado: Paciente = null;
  centroMedicoSeleccionado: CentroMedico = null;
  darkTheme: NgxMaterialTimepickerTheme = {
    container: {
      bodyBackgroundColor: "#ffffff",
      buttonColor: "#000000",
    },
    dial: {
      dialBackgroundColor: "#3434EC",
    },
    clockFace: {
      clockFaceBackgroundColor: "#EEEEEE",
      clockHandColor: "#05CE7C",
      clockFaceTimeInactiveColor: "#3434EC",
    },
  };
  listaServicios: any[] = [];
  servicioSeleccionado: any = null;
  mostrarServicioSelect = false;
  servicioFijo = false;
  diasSemanaOpciones = [
    { valor: 1, label: 'Lunes' },
    { valor: 2, label: 'Martes' },
    { valor: 3, label: 'Miércoles' },
    { valor: 4, label: 'Jueves' },
    { valor: 5, label: 'Viernes' },
    { valor: 6, label: 'Sábado' },
    { valor: 0, label: 'Domingo' },
  ];

  get diasSemanaOpcionesDisponibles() {
    const diasActivos = this.generarDiasSemanaActivo();
    return this.diasSemanaOpciones.filter(d => diasActivos.includes(d.valor));
  }
  public turnoDesdePaciente = false;
  private diasSemana = diasSemanaOrdenAnglo;
  private subscripciones = new Subscription();
  private diasActivosMédicoObs = new BehaviorSubject<number[]>([
    0, 1, 2, 3, 4, 5, 6, 7,
  ]);
  private diasActivosMedico: number[] = [];
  private listaDeTurnos: any[] = [];
  public diaActual = new Date();
  public loadingPacientePorDni = false;
  public agregarNuevoPaciente = false;
  public turnoViejo = false;
  private primeraValidacion = true;

  public pagosTurno: any[] = [];
  public servicioPago: any = null;
  public cargandoPagos = false;
  public enviandoLinkSaldo = false;

  public accionesEnHeader = false;

  //
  constructor(
    public dialogRef: MatDialogRef<TurnoAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public response: any,
    public turnosService: TurnosService,
    private tipoDocumentoService: TipoDocumentoService,
    private servicioService: ServicioService,
    private spinnerService: SpinnerService,
    private snackBar: MatSnackBar,
    private mercadopagoService: MercadopagoService,
    private responsiveService: ResponsiveService
  ) {}

  get esAdminEditando(): boolean {
    return this.editar && this.tipoUsuario === "usuario-panel";
  }

  get reservaPagada(): boolean {
    return this.pagosTurno.some(p => p.tipo === "reserva" && p.estado === "pagado");
  }

  get saldoPagado(): boolean {
    return this.pagosTurno.some(p => p.tipo === "saldo" && p.estado === "pagado");
  }

  get saldoPendiente(): boolean {
    return this.pagosTurno.some(p => p.tipo === "saldo" && p.estado === "pendiente");
  }

  get pagoUnicoPagado(): boolean {
    return this.pagosTurno.some(p => p.tipo === "unico" && p.estado === "pagado");
  }

  get puedeEnviarLinkSaldo(): boolean {
    return this.reservaPagada && !this.saldoPagado;
  }

  get hayQueMostrarPanelPagos(): boolean {
    return this.esAdminEditando && this.pagosTurno.length > 0;
  }

  cargarPagosTurno() {
    if (!this.esAdminEditando || !this.turno?.id) return;
    this.cargandoPagos = true;
    this.mercadopagoService.listarPagosTurno(this.turno.id).subscribe(
      (res) => {
        this.pagosTurno = res?.pagos || [];
        this.servicioPago = res?.servicio || null;
        this.cargandoPagos = false;
      },
      () => {
        this.cargandoPagos = false;
      }
    );
  }

  enviarLinkSaldo() {
    if (!this.turno?.id || this.enviandoLinkSaldo) return;
    this.enviandoLinkSaldo = true;
    this.mercadopagoService.enviarLinkSaldo(this.turno.id).subscribe(
      (res) => {
        this.enviandoLinkSaldo = false;
        if (res?.ok) {
          const message = res.email_enviado
            ? "Link de saldo enviado al paciente por email."
            : "Link generado pero el email no se envió. Revisá logs.";
          this.snackBar.openFromComponent(NotificationComponent, {
            data: { message, action: res.email_enviado ? "success" : "warning" },
            duration: 4000,
          });
          this.cargarPagosTurno();
        }
      },
      (err) => {
        this.enviandoLinkSaldo = false;
        const message = err?.error?.error || "No se pudo generar el link de saldo.";
        this.snackBar.openFromComponent(NotificationComponent, {
          data: { message, action: "error" },
          duration: 4000,
        });
      }
    );
  }

  //
  ngOnInit(): void {
    this.subscripciones.add(
      this.responsiveService.isShortScreen$.subscribe(
        (esPantallaBaja) => (this.accionesEnHeader = esPantallaBaja)
      )
    );

    this.editar = this.response.editar;
    this.turno = this.response.turno;
    this.usuario = this.response.usuario;
    this.listaPacientes = this.response.pacientes;
    this.filtroPacientes = this.response.pacientes;
    this.listaMedicos = this.response.medicos;
    this.filtroMedicos = this.response.medicos;
    this.listaCompletaMedicos = this.response.medicos;
    this.tipoUsuario = this.response.tipoUsuario;
    this.general = this.response.general;
    this.listaEspecialidades = this.response.especialidades;
    this.filtroEspecialidades = this.response.especialidades;
    this.turnoDesdePaciente = this.response?.turnoDesdePaciente;

    const centrosConMedicosYEspecialidad =
      this.response?.centrosMedicos?.filter((centro) =>
        this.response.medicos.some(
          (medico) =>
            medico.especialidad &&
            medico.agendaMedico?.some(
              (agenda) => agenda.id_sucursal === centro.id
            )
        )
      );

    this.listaCentrosMedicos = centrosConMedicosYEspecialidad;
    this.filtroCentroMedicos = centrosConMedicosYEspecialidad;

    this.response.turno
      ? this.iniciarFormularioEdicion()
      : this.iniciarFormulario();

    this.cargarPagosTurno();

    if (this.response.turnoDesdePaciente) {
      this.subscripciones.add(
        combineLatest([
          this.turnosService.getDatosAgendar(),
          this.tipoDocumentoService.listar(),
        ]).subscribe(
          ([
            { especialidades, medicos, centrosMedicos },
            { listaTipoDocumento },
          ]) => {
            this.listaCompletaMedicos = medicos;
            this.filtroMedicos = medicos;
            this.listaEspecialidades = especialidades;
            this.filtroEspecialidades = especialidades;
            this.tiposDocumentos = listaTipoDocumento;
            const centrosConMedicosYEspecialidad = centrosMedicos.filter(
              (centro) =>
                medicos.some(
                  (medico) =>
                    medico.especialidad &&
                    medico.agendaMedico?.some(
                      (agenda) => agenda.id_sucursal === centro.id
                    )
                )
            );

            this.listaCentrosMedicos = centrosConMedicosYEspecialidad;
            this.filtroCentroMedicos = centrosConMedicosYEspecialidad;
          }
        )
      );
    }

    this.subscripciones.add(
      this.diasActivosMédicoObs.subscribe((diasActivosMedico) => {
        this.diasActivosMedico = diasActivosMedico;
      })
    );

    if (this.turnoViejo) {
      this.formularioTurno.disable();
    }
  }

  get duracionTurnoActual(): string {
    if (this.servicioSeleccionado?.duracion) return this.servicioSeleccionado.duracion;
    if (this.editar && this.turno?.fecha_desde && this.turno?.fecha_hasta) {
      const minutos = moment(this.turno.fecha_hasta).diff(moment(this.turno.fecha_desde), "minutes");
      if (minutos > 0) {
        const h = String(Math.floor(minutos / 60)).padStart(2, "0");
        const m = String(minutos % 60).padStart(2, "0");
        return `${h}:${m}:00`;
      }
    }
    return this.general?.rangoHasta;
  }

  cargarServicios(especialidadId: number) {
    this.listaServicios = [];
    this.servicioSeleccionado = null;
    this.mostrarServicioSelect = false;
    this.servicioFijo = false;
    this.formularioTurno.patchValue({ servicio: '' });

    if (especialidadId && especialidadId !== 0) {
      this.servicioService.listar(especialidadId).subscribe(({ listaServicios }) => {
        this.listaServicios = listaServicios;
        this.aplicarRequiredServicio(listaServicios.length > 0);
        if (listaServicios.length === 1) {
          this.servicioSeleccionado = listaServicios[0];
          this.formularioTurno.patchValue({ servicio: listaServicios[0].id });
          this.mostrarServicioSelect = true;
          this.servicioFijo = true;
        } else if (listaServicios.length > 1) {
          this.mostrarServicioSelect = true;
          this.servicioFijo = false;
        }
      });
    } else {
      this.aplicarRequiredServicio(false);
    }
  }

  private aplicarRequiredServicio(required: boolean) {
    const ctrl = this.formularioTurno.get("servicio");
    ctrl.setValidators(required ? [Validators.required] : []);
    ctrl.updateValueAndValidity();
  }

  compararServicio = (a: any, b: any): boolean => {
    if (a == null || b == null) return a === b;
    return Number(a) === Number(b);
  };

  seleccionarServicio(servicioId: number) {
    this.servicioSeleccionado = this.listaServicios.find(s => s.id === servicioId) || null;
    this.formularioTurno.patchValue({
      fechaDesde: '',
      tiempoDesde: '',
    });
  }

  ngOnDestroy() {
    if (this.subscripciones) {
      this.subscripciones.unsubscribe();
    }

    this.formularioTurno.reset();
  }

  private iniciarFormulario() {
    this.formularioTurno.patchValue({
      id_medico: this.tipoUsuario === "medico" ? this.usuario?.id : "",
      medicoBuscador: "",
      centroMedico: 0,
      centroMedicoBuscador: "",
      especialidad: 0,
    });

    if (this.turnoDesdePaciente) {
      this.formularioTurno.patchValue({
        id_paciente: this.response.pacienteId,
      });
    }

    if (!this.turnoDesdePaciente) {
      this.setearFormatoFechaSegúnFecha();
    }

    if (this.tipoUsuario === "medico") {
      this.medicoSelecionado = this.filtroMedicos.find(
        (elemento) => elemento.id === this.usuario?.id
      );

      const agendasMedico = this.medicoSelecionado?.agendaMedico.map(
        (agenda) => agenda.id_sucursal
      );

      this.listaCentrosMedicos = this.listaCentrosMedicos.filter((centro) =>
        agendasMedico.includes(centro.id)
      );
      this.filtroCentroMedicos = this.filtroCentroMedicos.filter((centro) =>
        agendasMedico.includes(centro.id)
      );

      if (this.listaCentrosMedicos.length === 1) {
        this.centroMedicoSeleccionado = this.listaCentrosMedicos[0];
      }

      if (this.response.centroMedicoSeleccionado) {
        this.centroMedicoSeleccionado = this.response.centroMedicoSeleccionado;
      }

      this.formularioTurno.patchValue({
        id_medico: this.usuario?.id,
        especialidad: this.medicoSelecionado.especialidad,
        id_paciente:
          this.response.pacienteSeleccionado !== null
            ? this.response.pacienteSeleccionado?.id
            : "",
        centroMedico:
          this.listaCentrosMedicos.length === 1
            ? this.listaCentrosMedicos[0].id
            : this.response.centroMedicoSeleccionado
            ? this.response.centroMedicoSeleccionado.id
            : "",
      });

      this.cargarServicios(this.medicoSelecionado.especialidad);
      this.cargarTurnosMedico(this.usuario?.id);
    }
  }

  private cargarTurnosMedico(idMedico: number) {
    this.turnosService
      .turnoDeUnMedico(idMedico)
      .subscribe((turnos) => (this.listaDeTurnos = turnos));
  }

  private setFormDates(start: Date, end: Date): void {
    this.formularioTurno.patchValue({
      fechaDesde: start,
      fechaHasta: end,
    });
  }

  private setFormTimes(start: Date, end: Date): void {
    this.formularioTurno.patchValue({
      tiempoDesde: moment(start).format("HH:mm"),
      tiempoHasta: moment(end).format("HH:mm"),
    });
  }

  private setearFormatoFechaSegúnFecha() {
    const viewTypeHandlers = {
      dayGridMonth: () => {
        this.setFormDates(
          this.response.selectInfo.start,
          this.response.selectInfo.start
        );
      },
      timeGridWeek: () => {
        this.setFormTimes(
          this.response.selectInfo.start,
          this.response.selectInfo.end
        );
        this.setFormDates(
          this.response.selectInfo.start,
          this.response.selectInfo.start
        );
      },
      timeGridDay: () => {
        this.setFormTimes(
          this.response.selectInfo.start,
          this.response.selectInfo.end
        );
        this.setFormDates(
          this.response.selectInfo.start,
          this.response.selectInfo.start
        );
      },
    };

    const viewType = this.response.selectInfo?.view.type;
    if (viewType in viewTypeHandlers) {
      viewTypeHandlers[viewType]();
    }
  }

  //
  iniciarFormularioEdicion() {
    this.medicoSelecionado = this.filtroMedicos.find(
      (elemento: any) => elemento.id == this.turno.id_medico
    );

    this.pacienteSeleccionado = this.filtroPacientes.find(
      (elemento: any) => elemento.id == this.turno.id_paciente
    );

    this.centroMedicoSeleccionado = this.filtroCentroMedicos.find(
      (elemento: any) => elemento.id == this.turno.id_centromedico
    );


    const horaDesde = moment(this.turno.fecha_desde).format("HH:mm");
    const horaHasta = moment(this.turno.fecha_hasta).format("HH:mm");
    const slotTurno = `${horaDesde} - ${horaHasta}`;

    if (!this.turnoDesdePaciente) {
      this.setearFormatoFechaSegúnFecha();
    }

    this.formularioTurno.patchValue({
      id: this.turno.id,
      titulo: this.turno.titulo,
      detalle: this.turno.detalle,
      id_paciente: this.turno.id_paciente,
      especialidad: this.medicoSelecionado.especialidad
        ? this.medicoSelecionado.especialidad
        : 0,
      pacienteBuscador: "",
      centroMedico: this.turno.id_centromedico,
      centroMedicoBuscador: "",
      id_medico: this.turno.id_medico,
      medicoBuscador: "",
      fechaDesde: new Date(this.turno.fecha_desde),
      fechaHasta: new Date(this.turno.fecha_hasta),
      tiempoDesde: slotTurno,
    });

    this.turnoViejo =
      this.turno.fecha_desde.split(" ")[0] <
      this.diaActual.toISOString().split("T")[0];

    this.validarMedicoEmail(this.turno.id_medico);
    if (!this.editar) {
      this.validarCentroMedico(this.turno.id_centromedico);
    }

    if (this.medicoSelecionado?.especialidad) {
      this.servicioService.listar(this.medicoSelecionado.especialidad).subscribe(({ listaServicios }) => {
        this.listaServicios = listaServicios;
        this.aplicarRequiredServicio(listaServicios.length > 0);
        if (listaServicios.length === 1) {
          this.servicioSeleccionado = listaServicios[0];
          this.mostrarServicioSelect = true;
          setTimeout(() => this.formularioTurno.patchValue({ servicio: listaServicios[0].id }));
        } else if (listaServicios.length > 1) {
          this.mostrarServicioSelect = true;
          if (this.turno.id_servicio) {
            this.servicioSeleccionado = listaServicios.find(s => s.id === this.turno.id_servicio) || null;
            setTimeout(() => this.formularioTurno.patchValue({ servicio: this.turno.id_servicio }));
          }
        }
      });
    }

    this.formularioTurno.get("id_paciente").disable();
    this.formularioTurno.get("centroMedico").disable();
    this.formularioTurno.get("especialidad").disable();
    setTimeout(() => {
      this.formularioTurno.get("id_medico").disable();
    });
  }

  //
  filtrarEspecialidad(event: any) {
    let valorString: string = this.formularioTurno.get(
      "especialidadBuscador"
    ).value;
    let array = [];
    for (let ops of this.listaEspecialidades) {
      if (ops.texto.toUpperCase().includes(valorString.toUpperCase())) {
        let nuevoE: any = ops;
        array.push(nuevoE);
      }
    }
    this.filtroEspecialidades = array;
  }

  //
  filtrarMedico(event: any) {
    let valorString: string = this.formularioTurno.get("medicoBuscador").value;
    this.filtroMedicos = [];

    for (let ops of this.listaMedicos) {
      if (
        ops.nombreCompleto.toUpperCase().includes(valorString.toUpperCase())
      ) {
        let nuevoM: any = ops;
        this.filtroMedicos.push(nuevoM);
      }
    }
  }

  //
  filtrarCentroMedico(event: any) {
    let valorString: string = this.formularioTurno.get(
      "centroMedicoBuscador"
    ).value;
    this.filtroCentroMedicos = [];

    for (let ops of this.listaCentrosMedicos) {
      if (ops.nombre.toUpperCase().includes(valorString.toUpperCase())) {
        let nuevoCM: any = ops;
        this.filtroCentroMedicos.push(nuevoCM);
      }
    }
  }

  filtrarEspecialidadMedico() {
    let especialidad: any = this.formularioTurno.get("especialidad").value;

    let medicosFiltrados = [];

    for (let medico of this.listaCompletaMedicos) {
      // Verificar si el médico trabaja en el centro médico seleccionado
      const trabajaEnCentro = this.centroMedicoSeleccionado
        ? medico?.agendaMedico
            .map((a) => a.id_sucursal)
            .includes(this.centroMedicoSeleccionado?.id)
        : true; // Si no hay centro seleccionado, incluir todos

      if (!trabajaEnCentro) continue;

      // Filtrar por especialidad
      if (especialidad == 0 || medico.especialidad == especialidad) {
        medicosFiltrados.push(medico);
      }
    }

    this.listaMedicos = medicosFiltrados;
    this.filtroMedicos = medicosFiltrados;

    // Reiniciar médico seleccionado y campos del formulario
    this.medicoSelecionado = null;
    this.formularioTurno.patchValue({
      id_medico: "",
      fechaDesde: "",
      tiempoDesde: "",
    });

    // Cargar servicios de la especialidad seleccionada
    this.cargarServicios(especialidad);
  }

  //
  filtrarPaciente(event: any) {
    let valorString: string =
      this.formularioTurno.get("pacienteBuscador").value;
    this.filtroPacientes = [];

    for (let ops of this.listaPacientes) {
      if (
        ops.nombreApellido.toUpperCase().includes(valorString.toUpperCase())
      ) {
        let nuevoP: any = ops;
        this.filtroPacientes.push(nuevoP);
      }
    }
  }

  //
  validarMedicoEmail(medicoId: number) {
    this.medicoSelecionado = this.filtroMedicos.find(
      (m: MedicoConDiasTurno) => m.id == medicoId
    );

    if (this.medicoSelecionado) {
      this.diasActivosMédicoObs.next(this.generarDiasSemanaActivo());
      this.cargarTurnosMedico(this.medicoSelecionado.id);
    }

    this.formularioTurno.patchValue({
      diasSemanaRango: [],
      horaDesdeRango: "",
    });

    if (!this.primeraValidacion && !this.editar) {
      this.setearFormatoFechaSegúnFecha();
    }

    if (this.primeraValidacion && !this.editar) {
      this.primeraValidacion = false;
    }
  }

  //
  validarPacienteEmail(paacienteId: number) {
    this.pacienteSeleccionado = this.filtroPacientes.find(
      (p: Paciente) => p.id == paacienteId
    );
  }

  validarCentroMedico(centroMedicoId: number) {
    this.centroMedicoSeleccionado = this.filtroCentroMedicos.find(
      (cm: CentroMedico) => cm.id == centroMedicoId
    );

    if (this.response.tipoUsuario === "medico") {
      this.diasActivosMédicoObs.next(this.generarDiasSemanaActivo());
    }

    let array = [];

    for (let ops of this.listaCompletaMedicos) {
      if (
        ops?.agendaMedico
          .map((a) => a.id_sucursal)
          .includes(this.centroMedicoSeleccionado?.id)
      ) {
        let nuevoM: any = ops;
        array.push(nuevoM);
      }
    }

    this.listaMedicos = array;
    this.filtroMedicos = array;

    // Ahora filtramos las especialidades basándonos solo en los médicos de este centro médico
    if (array.length > 0) {
      let especialidadesDisponibles = [];
      array.forEach((medico) => {
        if (
          medico.especialidad &&
          !especialidadesDisponibles.some((e) => e.id == medico.especialidad)
        ) {
          const especialidad = this.listaEspecialidades.find(
            (e) => e.id == medico.especialidad
          );
          if (especialidad) {
            especialidadesDisponibles.push(especialidad);
          }
        }
      });
      this.filtroEspecialidades = especialidadesDisponibles;
    } else {
      this.filtroEspecialidades = [];
    }

    if (this.tipoUsuario !== "medico") {
      this.formularioTurno.patchValue({
        id_medico: "",
        especialidad: 0,
      });
    }

    this.formularioTurno.patchValue({
      diasSemanaRango: [],
      horaDesdeRango: "",
    });

    if (this.response?.selectInfo?.start) {
      this.setearFormatoFechaSegúnFecha();
      this.formularioTurno.patchValue({
        tiempoDesde: "",
      });
    }

    if (!this.response?.selectInfo?.start) {
      this.formularioTurno.patchValue({
        fechaDesde: "",
        tiempoDesde: "",
      });
    }
  }

  //
  guardarTurno() {
    if (this.formularioTurno.value.modoRango && !this.editar) {
      this.crearTurnosRango();
      return;
    }
    this.formatearYEnviarTurno();
  }

  //
  crearTurnosRango() {
    if (!this.formularioRangoValido()) {
      this.openSnackBar("Completá todos los campos del rango", "error");
      return;
    }

    const v = this.formularioTurno.value;
    const slot = v.horaDesdeRango || "";
    const horaDesde = slot.split("-")[0]?.trim();
    const horaHasta = slot.split("-")[1]?.trim();
    const payload = {
      id_medico: v.id_medico,
      id_paciente: v.id_paciente,
      centroMedico: v.centroMedico,
      servicio: v.servicio,
      titulo: v.titulo,
      detalle: v.detalle,
      fecha_rango_desde: v.rangoFechaDesde,
      fecha_rango_hasta: v.rangoFechaHasta,
      dias_semana: v.diasSemanaRango,
      hora_desde: horaDesde,
      hora_hasta: horaHasta,
    };

    this.spinnerService.mostrarSpinner();
    this.turnosService.crearTurnosRango(payload).subscribe(
      (data: any) => {
        this.spinnerService.ocultarSpinner();
        const total = data.totalCreados;
        const omitidos = data.totalOmitidos;
        let mensaje = `Se crearon ${total} turno${total === 1 ? '' : 's'}`;
        if (omitidos > 0) {
          mensaje += `. ${omitidos} omitido${omitidos === 1 ? '' : 's'} por conflicto`;
          console.warn('Turnos omitidos:', data.omitidos);
        }
        this.openSnackBar(mensaje, total > 0 ? "exito" : "error");
        if (total > 0) {
          this.dialogRef.close({ estado: 1 });
        }
      },
      (error) => {
        console.log(error);
        this.spinnerService.ocultarSpinner();
        const msg = error?.error?.error || "No se pudieron crear los turnos del rango";
        this.openSnackBar(msg, "error");
      }
    );
  }

public formularioRangoValido(): boolean {
    const v = this.formularioTurno.value;
    const dias: number[] = v.diasSemanaRango || [];
    return !!(
      v.rangoFechaDesde && v.rangoFechaHasta && dias.length > 0 &&
      v.horaDesdeRango && v.id_paciente && v.id_medico && v.centroMedico
    );
  }

  private fechaEjemploDiaSemana(diaSemana: number): Date | null {
    const desde = this.formularioTurno.value.rangoFechaDesde;
    const hasta = this.formularioTurno.value.rangoFechaHasta;
    if (!desde || !hasta) return null;

    const cursor = new Date(desde);
    const fin = new Date(hasta);
    while (cursor.getTime() <= fin.getTime()) {
      if (cursor.getDay() === diaSemana) return new Date(cursor);
      cursor.setDate(cursor.getDate() + 1);
    }
    return null;
  }

  public listaHorariosRango(): string[] {
    const dias: number[] = this.formularioTurno.value.diasSemanaRango || [];
    if (dias.length === 0 || !this.diasSemanaRangoTienenAgenda()) return [];

    const agenda = this.getAgendaActual();
    if (!agenda) return [];

    const candidatos = new Set<string>();
    for (const d of dias) {
      const fecha = this.fechaEjemploDiaSemana(d);
      if (!fecha) continue;
      for (const slot of this.generarListaDeTodosLosTurnos(fecha)) {
        candidatos.add(slot);
      }
    }

    const tramosPorDia = dias.map((d) =>
      tramosDelDiaAgenda(agenda, diasSemanaOrdenAnglo[d])
    );

    const toMin = (t: string) => {
      const [h, m] = t.split(":").map(Number);
      return h * 60 + m;
    };

    const filtrados = Array.from(candidatos).filter((slot) => {
      const [start, end] = slot.split(" - ").map((s) => s.trim());
      const s = toMin(start);
      const e = toMin(end);
      return tramosPorDia.every((tramos) =>
        tramos.some((t) => toMin(t.desde) <= s && e <= toMin(t.hasta))
      );
    });

    filtrados.sort();
    return filtrados;
  }

  public diasSemanaRangoTienenAgenda(): boolean {
    const dias: number[] = this.formularioTurno.value.diasSemanaRango || [];
    if (dias.length === 0) return false;
    const diasActivos = this.generarDiasSemanaActivo();
    return dias.every((d) => diasActivos.includes(d));
  }

  private formatearYEnviarTurno() {
    this.formularioTurno.patchValue({
      fechaHasta: this.formularioTurno.value.fechaDesde,
      tiempoHasta: this.formularioTurno.value.tiempoDesde,
    });

    const fechaDesde = this.formatearFecha(
      this.formularioTurno.get("fechaDesde").value,
      this.formularioTurno.get("tiempoDesde").value
    );

    const fechaHasta = this.formatearFecha(
      this.formularioTurno.get("fechaHasta").value,
      this.formularioTurno.get("tiempoHasta").value,
      true
    );

    this.editar
      ? this.validarFechaEditar(
          {
            ...this.formularioTurno.value,
            id_medico: this.turno.id_medico,
            id_paciente: this.turno.id_paciente,
            centroMedico: this.turno.id_centromedico,
          },
          fechaDesde,
          fechaHasta
        )
      : this.validarFecha(this.formularioTurno.value, fechaDesde, fechaHasta);
  }

  private formatearFecha(fechaAFormatear: Date, tiempoAFormatear: string, esHasta = false): string {
    const idx = esHasta ? 1 : 0;
    return `${moment(fechaAFormatear).format("YYYY-MM-DD")} ${tiempoAFormatear
      .split("-")[idx]
      .trim()}`;
  }

  //
  validarFecha(formularioTurno: any, fechaDesde: any, fechaHasta: any) {
    if (this.formularioTurno.valid) {
      this.spinnerService.mostrarSpinner();
      this.turnosService
        .validarTurno(formularioTurno, fechaDesde, fechaHasta)
        .subscribe(
          (data) => {
            let response: any = data;
            this.fechaError = response.fechaError;
            if (this.fechaError == "") {
              this.crearTurno(formularioTurno, fechaDesde, fechaHasta);
            } else {
              this.spinnerService.ocultarSpinner();
              this.openSnackBar("Guardado fallido", "error");
            }
          },
          (error) => {
            this.spinnerService.ocultarSpinner();
            this.openSnackBar(mensajeError(error, "Guardado fallido"), "error");
          }
        );
    } else {
      this.openSnackBar(
        camposFaltantes(this.formularioTurno, {
          id_paciente: "Paciente",
          id_medico: "Médico",
          centroMedico: "Centro médico",
          fechaDesde: "Fecha",
          tiempoDesde: "Horarios",
          servicio: "Servicio",
        }),
        "error",
      );
    }
  }

  //
  crearTurno(formularioTurno: any, fechaDesde: any, fechaHasta: any) {
    this.turnosService
      .crearTurno(formularioTurno, fechaDesde, fechaHasta)
      .subscribe(
        (data) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar("Guardado exitoso", "exito");
          this.dialogRef.close({ estado: 1 });
        },
        (error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(mensajeError(error, "Guardado fallido"), "error");
        }
      );
  }

  //
  validarFechaEditar(formularioTurno: any, fechaDesde: any, fechaHasta: any) {
    if (this.formularioTurno.valid) {
      this.spinnerService.mostrarSpinner();
      this.turnosService
        .validarTurnoEditar(formularioTurno, fechaDesde, fechaHasta)
        .subscribe(
          (data) => {
            let response: any = data;
            this.fechaError = response.fechaError;
            if (this.fechaError == "") {
              this.editarTurno(formularioTurno, fechaDesde, fechaHasta);
            } else {
              this.spinnerService.ocultarSpinner();
              this.openSnackBar("Editado fallido", "error");
            }
          },
          (error) => {
            this.spinnerService.ocultarSpinner();
            this.openSnackBar(mensajeError(error, "Editado fallido"), "error");
          }
        );
    } else {
      this.openSnackBar(
        camposFaltantes(this.formularioTurno, {
          id_paciente: "Paciente",
          id_medico: "Médico",
          centroMedico: "Centro médico",
          fechaDesde: "Fecha",
          tiempoDesde: "Horarios",
          servicio: "Servicio",
        }),
        "error",
      );
    }
  }

  //
  editarTurno(formularioTurno: any, fechaDesde: any, fechaHasta: any) {
    this.turnosService
      .editarTurno(formularioTurno, fechaDesde, fechaHasta)
      .subscribe(
        (data) => {
          this.openSnackBar("Editado exitoso", "exito");
          this.dialogRef.close({ estado: 1 });
        },
        (error) => {
          this.spinnerService.ocultarSpinner();
          this.openSnackBar(mensajeError(error, "Editado fallido"), "error");
        }
      );
  }

  //
  cambiarTurno(event: Event, tipoValor: any) {
    this.fechaError = "";
    if (tipoValor == "tiempoDesde") {
      let rangoHasta = moment(this.duracionTurnoActual, "HH:mm");
      let fechaDesde = this.formularioTurno.get("fechaDesde");
      let fechaHasta = this.formularioTurno.get("fechaHasta");
      let tiempoDesde = this.formularioTurno.get("tiempoDesde");
      let tiempoHasta = this.formularioTurno.get("tiempoHasta");
      if (!tiempoHasta.value && rangoHasta.isValid()) {
        let fechaMomentDesde = moment(fechaDesde.value); //.format('YYYY-MM-DD');
        let fechaMomentHasta = moment(fechaHasta.value); //.format('YYYY-MM-DD');
        if (fechaMomentDesde.isSame(fechaMomentHasta)) {
          let fechaTotalDesde = moment(
            `${fechaMomentDesde.format("YYYY-MM-DD")} ${tiempoDesde.value}`,
            "YYYY-MM-DD HH:mm"
          );
          let sumaMoment = fechaTotalDesde
            .add(rangoHasta.hours(), "hours")
            .add(rangoHasta.minutes(), "minutes");
          tiempoHasta.setValue(sumaMoment.format("HH:mm"));
          fechaHasta.setValue(
            new Date(sumaMoment.year(), sumaMoment.month(), sumaMoment.date())
          );
        } else {
          let tiempoMomentDesde = moment(tiempoDesde.value, "HH:mm");
          let sumaMoment = tiempoMomentDesde
            .add(rangoHasta.hours(), "hours")
            .add(rangoHasta.minutes(), "minutes");
          tiempoHasta.setValue(sumaMoment.format("HH:mm"));
        }
      }
    }
  }

  //
  cancelar() {
    this.dialogRef.close();
  }

  //
  borrarTurno() {
    this.dialogRef.close({
      id: this.turno.id,
      estado: 2,
    });
  }

  //
  cerrar() {
    this.dialogRef.close();
  }

  //
  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: {
        message: message[0].toUpperCase() + message.slice(1),
        action: action,
      },
      duration: 2500,
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: [action],
    });
  }

  public generarListaDeTodosLosTurnos(day: Date): string[] {
    const agenda = this.medicoSelecionado ? this.getAgendaActual() : null;
    return generarSlotsParaDia(day, agenda, this.diaActual, this.duracionTurnoActual);
  }

  public listaDeTurnosSinLosYaOtorgados(): string[] {
    const diaSeleccionado = new Date(this.formularioTurno.value.fechaDesde);

    const listaDeTurnosSinLosTurnosOtorgados = this.horariosLibres(diaSeleccionado);

    return listaDeTurnosSinLosTurnosOtorgados.length === 0
      ? ["No quedan turnos disponibles"]
      : listaDeTurnosSinLosTurnosOtorgados;
  }

  generarDiasSemanaActivo(): number[] {
    const diasSemana: number[] = [];

    if (this.getAgendaActual()?.lunes_desde !== null) {
      diasSemana.push(1);
    }
    if (this.getAgendaActual()?.martes_desde !== null) {
      diasSemana.push(2);
    }
    if (this.getAgendaActual()?.miercoles_desde !== null) {
      diasSemana.push(3);
    }
    if (this.getAgendaActual()?.jueves_desde !== null) {
      diasSemana.push(4);
    }
    if (this.getAgendaActual()?.viernes_desde !== null) {
      diasSemana.push(5);
    }
    if (this.getAgendaActual()?.sabado_desde !== null) {
      diasSemana.push(6);
    }
    if (this.getAgendaActual()?.domingo_desde !== null) {
      diasSemana.push(0);
    }

    return diasSemana;
  }

  private turnosPorMedico() {
    const medico = this.medicoSelecionado?.id;
    if (!medico) return [];

    return this.listaDeTurnos.filter((turno) => turno.id_medico == medico);
  }

  private horariosLibres(day: Date): string[] {
    return slotsLibres(
      this.generarListaDeTodosLosTurnos(day),
      this.turnosPorMedico(),
      day,
      this.turno?.id
    );
  }

  private diaCompleto(day: Date): boolean {
    return this.horariosLibres(day).length === 0;
  }

  private filtrarFechasDatePicker(d: Date | null): boolean {
    const day = d || new Date();

    return (
      this.diasActivosMedico?.includes(day.getDay()) && !this.diaCompleto(day)
    );
  }

  public boundedFiltrarFechasDatePicker =
    this.filtrarFechasDatePicker.bind(this);

  public seleccionarHorario(event: MatSelectChange) {
    this.formularioTurno.patchValue({
      tiempoDesde: event.value,
    });
  }

  public onDiaSemanaRangoChange() {
    this.formularioTurno.patchValue({ horaDesdeRango: "" });
  }

  public handleDniInputEvent() {
    return this.formularioTurno.controls.dniPaciente.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      catchError(() => {
        this.openSnackBar("Error al buscar paciente", "Cerrar");
        return of(null);
      })
    );
  }

  public handleAgregarNuevoPaciente() {
    if (this.pacienteSeleccionado) {
      this.agregarNuevoPaciente = false;
      this.pacienteSeleccionado = null;
    }
  }

  public getAgendaActual(): Agenda {
    const agenda = this.medicoSelecionado?.agendaMedico?.find(
      (agenda) => agenda.id_sucursal === this.centroMedicoSeleccionado?.id
    );
    return agenda ?? null;
  }
}
